<div class="alert-content" mat-dialog-content>
    <div class="red-alert-title" i18n="Mark card transaction as debt">Mark as debt?</div>
    <p i18n="Would you like to mark this transaction as a debt? Now you can decrease your company dept to your for [amount]">
        Would you like to mark this transaction as a debt? Now you can decrease your company dept to your for <span [innerHTML]="amount | amount"></span></p>
</div>
<mat-dialog-actions class="red-alert-actions">
    <button mat-button class="mat-primary" tabindex="-1" (click)="cancel()" i18n="Cancel button label">Cancel</button>
    <button mat-button class="mat-primary" tabindex="-1" (click)="confirm()" i18n="Mark as debt button label">Mark as debt</button>
</mat-dialog-actions>
